const { client, loadToken } = require('./client');
export { loadToken };

export async function getAllSites() {
    var { data } = await client.get(`/sites`);

    return data;
}


export async function getAllCameraLocations(){
  var {data} = await client.get(`/sites/camera`);
  return data;
}

const all = {
    loadToken, getAllSites, getAllCameraLocations
};

export default all;